module.exports = __webpack_public_path__ + "img/list.5ed81d50.svg";